// extracted by mini-css-extract-plugin
export default {"entriesSelectTextFix":"SavedSurveyList_entriesSelectTextFix__vFu12"};